import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { getCookie } from "cookies-next";
import { useEffect } from "react";
import { Outlet } from "react-router-dom";

import ToastContainer from "@components/container/ToastContainer";
import Modal from "@components/modal/Modal";
import { OpenAPI as AdminOpenAPI } from "@generated/admin/core/OpenAPI";
import { OpenAPI as AdWebviewOpenAPI } from "@generated/ad-webview/core/OpenAPI";
import { OpenAPI as AdChannelAdminOpenAPI } from "@generated/ad-channel-admin/core/OpenAPI";
import { OpenAPI as FrontOpenAPI } from "@generated/front/core/OpenAPI";
import { OpenAPI as AnalyticsOpenAPI } from "@generated/analytics/core/OpenAPI";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

// 앱 시작 시 쿠키에서 토큰을 읽어 OpenAPI에 설정
function initializeAuth() {
  const adminToken = getCookie("adminToken") as string | undefined;
  const partnerToken = getCookie("partnerToken") as string | undefined;
  const userToken = getCookie("token") as string | undefined;

  if (adminToken) {
    AdminOpenAPI.TOKEN = adminToken;
    AnalyticsOpenAPI.TOKEN = adminToken;
  }

  if (partnerToken) {
    AdChannelAdminOpenAPI.TOKEN = partnerToken;
  }

  if (userToken) {
    FrontOpenAPI.TOKEN = userToken;
    AdWebviewOpenAPI.TOKEN = userToken;
  }
}

function App() {
  useEffect(() => {
    initializeAuth();
  }, []);

  return (
    <QueryClientProvider client={queryClient}>
      <div
        style={
          {
            "--color-brand-primary": "#3b82f6",
            "--color-brand-secondary": "#2563eb",
            "--color-brand-tertiary": "#1e40af",
          } as React.CSSProperties
        }
      >
        <Outlet />
        <ToastContainer />
        <Modal />
      </div>
    </QueryClientProvider>
  );
}

export default App;
